import styled from "styled-components";

// let isoemps = sessionStorage.getItem("channel") === "OEMAPS1"
export const MissionsCardRootDiv  = styled.div`
    width: 94%;
    background: ${(props)=>props.isoemps ? 'linear-gradient(#232A35, #141920) padding-box,linear-gradient(to right, #59462E, #CFB88D, #59462E) border-box' : '#E7EBEE'};
    min-height: 6.313rem;
    border-radius: 0.5rem;
    display: flex;
    /* margin: 1rem 0; */
    border:${(props)=>props.isoemps ? ' 0.5px solid transparent;' : ' 1px solid #1E3964'};
    align-items: center;
    justify-content: center;
    position: relative;
    
    /* z-index: 9; */
`
export const ExpiryNoteDiv = styled.div`
    width: 94%;
    border-radius: 0.5rem;
    border-bottom: 1px solid #2C5391;
    border-left: 1px solid #2C5391;
    border-right: 1px solid #2C5391;
    background: #12223E;
    color: #F2F2F2;
    font-size: 0.625rem;
    font-weight: 400;
    height: 1.75rem;
    /* margin-top: 0.5rem; */
    /* padding-bottom: 0.5rem; */
    position: relative;
    top: -0.15rem;
    /* margin-left: 1%; */
    z-index: 8;

`
export const MissionRewardDiv = styled.div`
    width: 27%;
    background-color: ${(props)=>props.isoemps ? 'rgba(89, 70, 46, 1)' : '#1E3964'};
    border-radius: 6px 0px 0px 6px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    /* gap: 0.5rem; */

`

export const MissionDetailsDiv = styled.div`
    width: 73%;
    border-radius: 0px 6px 6px 0px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
`

export const MissionTitleDiv = styled.div`
    display: flex;
    color:  ${(props)=>props.isoemps ? 'rgba(233, 223, 206, 1)' : '#032146'};
    font-weight: 700;
    font-size: 0.875rem;
    width: 94%;
    /* height: 50%; */
    /* flex-direction: column; */
    justify-content: space-between;
    align-items: flex-start;
    
`
export const MissionActionItemsDiv = styled.div`
    display: flex;
    color: ${(props)=> props.isoemps ? 'rgba(233, 223, 206, 1)' : '#032146'};
    font-weight: 700;
    font-size: 0.875rem;
    width: 94%;
    justify-content: space-between;
    /* height: 50%; */
    
`
export const ButtonDiv = styled.div`
  color: #ffffff;
  background: linear-gradient(180deg, #42be40 0%, #196a29 100%);
  font-weight: 500;
  font-size: 0.75rem;
  padding: 0.375rem 1.25rem;
  border-radius: 0.25rem;
`;

export const ExpireSectionDiv = styled.div`
  width: 94%;
  color: #c62828;
  font-size: 0.75rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  border-top: 0.5px solid #99a3b1;
  padding: 0.3125rem;
  position: relative;
  bottom: -0.5rem;
`;

export const ProgressbarDiv = styled.div`
  display: flex;
  height: 0.375rem;
  align-items: center;
  width: 100%;
  /* justify-content: space-between; */
  /* width: 100%; */
  border-radius: 8px;
`;

export const ProgressBar = styled.div`
  width: 100%;
  display: flex;
  height: 0.375rem;
  padding-right: 0px;
  align-items: center;
  border: ${(props) => (props.shouldShade === true ? '' : props.isoemps ? "none" : '1px solid #075063')};
  box-shadow: ${(props)=>props.isoemps ? '0px 0.5px 1px 0px rgba(158, 195, 216, 0.25)' : "0px 0.5px 1px 0px #9ec3d840"}; 
  box-shadow: ${(props)=>props.isoemps ? '0px 1px 3px 0px rgba(0, 0, 0, 0.13) inset' : "0px 1px 3px 0px #00000021 inset"};
  /* box-shadow: 0px 0.5px 1px 0px #9ec3d840; //${(props) =>
    props.shouldShade === true ? '0px 0.5px 1px 0px #9EC3D840' : '0px 0.5px 1px 0px #9EC3D840'};
  box-shadow: 0px 1px 3px 0px #00000021 inset; //${(props) =>
    props.shouldShade === true ? '0px 1px 3px 0px #00000021 inset' : '0px 1px 3px 0px #00000021 inset'}; */
  border-radius: 8px;
  background: ${(props) =>props.isoemps ? "rgba(0, 0, 0, 1)" :
    props.shouldShade === true
      ? '#707070'
      : props.isFromBundle === true
      ? '#080D1A'
      : '#1E3964'}; // rgba(25, 106, 41, 0.25);
  /* background: ${(props) => (props.shouldShade === true ? '#707070' : '#42BE40')};  */
  /* box-shadow: 0px 1px 1px rgba(158, 195, 216, 0.25); */
`;

export const ProgressBarFilled = styled.div`
  height: 0.25rem;
  border-radius: 8px 8px 8px 8px;
  background: ${(props) => props.isoemps ? "rgba(207, 184, 141, 1)" : (props.shouldShade === true ? '#BABABA' : '#42BE40')}; //#196A29;
  width: ${(props) => (props.fillArea ? props.fillArea : '10%')};
  /* ${(props) => (props.isSelected ? '0.1875rem solid #032146' : '')}; */
`;

export const ProgressBarText = styled.div`
  display: flex;
  color: ${(props)=>props.isoemps ? 'rgba(233, 223, 206, 1)' : '#1e3964'};
  align-items: center;
  font-size: 0.75rem;
  font-weight: 500;
`;

export const ExpiredStamp = styled.div`
  background: ${(props)=>props.isoemps ? 'rgba(15, 16, 20, 0.8)' : "#BABABA80"};
  border:${(props)=>props.isoemps ? '2px solid rgba(103, 109, 122, 1)' : "2px solid #4F5153"}; 
  padding: 6px 8px 6px 8px;
  color: ${(props)=>props.isoemps ? 'rgba(103, 109, 122, 1)' : "white"}; ;
  height: 1.75rem;
  position: absolute;
  rotate: -25deg;
  border-radius: 3.52px;
  display: flex;
`
export const LeftContentTextDiv = styled.div`
  font-size: 0.75rem;
  color: ${(props)=>props.isoemps ? 'rgba(233, 223, 206, 1)' : "#FFFFFF"};;
  font-weight: 400;
`